import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import profilePic from "../../assets/pfp.jpg";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={profilePic} alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, My name is{" "}
                <span className="different">Saphal Sherchan </span> and I am from{" "}
                <span className="different">
                  {" "}
                  Kathmandu (Nepal)
                </span>
                . I have completed my Bachelors Degree in Computing (Hons)
                from{" "}
                <span className="different">
                  Coventry University, London
                </span>
                . I was first hired as a React Intern in{" "}
                <span className="different">Techxillence</span> ,a remote company and later i worked as a <span className="different"> Software Engineer Level I.</span>
                       </h4>
              <h4>Words that best describe me :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Leadership 
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Motivated
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Tech Enthusiast
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Goal-oriented
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
